import styles from './LoadingSpinner.module.scss'

export default function LoadingSpinner() {
  return (
    <div className={styles.section}>
      <img src="/img/loading.svg" className={styles.spinner} />
    </div>
  )
}
